import { render } from "./EventviewBet.vue?vue&type=template&id=1a7846d0"
import script from "./EventviewBet.vue?vue&type=script&lang=js"
export * from "./EventviewBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__